import Vue from 'vue'
import Router from 'vue-router'
import moduleRouter from './fileLoad'
import routerData from './mould'

import vueResource from 'vue-resource'

Vue.use(Router)
Vue.use(vueResource)

export default new Router({
  base: '/',
  routes: [{
    path: '/',
    name: routerData.index.name,
    component: moduleRouter.index
  }, {
    path: routerData.index.path,
    redirect: '/'
  }, {
    path: routerData.article.path,
    name: routerData.article.name,
    component: moduleRouter.article
  }, {
    path: routerData.activity.path,
    name: routerData.activity.name,
    component: moduleRouter.activity
  }, {
    path: routerData.activityDetails.path,
    name: routerData.activityDetails.name,
    component: moduleRouter.activityDetails,
    props: true
  }, {
    path: routerData.pay.path,
    name: routerData.pay.name,
    component: moduleRouter.pay
  }, {
    path: routerData.notFind.path,
    name: routerData.notFind.name,
    component: moduleRouter.notFind
  }]
})



// WEBPACK FOOTER //
// ./src/router/router.js